export const IP_REGEX =
	/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

export const PASSWORD_MIN_SYMBOLS = 8
export const PASSWORD_MAX_SYMBOLS = 4096

export const COIN_USDT = "USDT"
